import React, {useState} from 'react';
import DashboardTemplate1 from "../components/dashboard-template-1";
import PageHeader from "../components/page-header";

function Index(props) {
    const [quickReports, setQuickReports] = useState([
        {title:"total-messages", value:"12,345", badge:"+12%"},
        {title:"active-devices", value:"6/8"},
        {title:"active-apps", value:"12", badge:"+3"},
        {title:"all-user-contacts",value:"00"},
    ]);
    const [help, setHelp] = useState(
        // [{title:"title", description:"description"}]
    );
    return (
        <div className="h-full overflow-hidden pb-3">
            <PageHeader title={props.name} description={props.description}/>
            <DashboardTemplate1 quickReports={quickReports} help={help}/>
        </div>
    );
}

export default Index;